export const _formatNameForSort = (name) => {
  const match = name.match(/^(\d+\w*)\s.*$/i)
  if (!match) return name
  const result = name.split(' ')
  result.shift()
  return `${result.join(' ')} ${match[1]}`
}

export const alphabeticalSort = (elems, iteratee) => {
  return elems.sort((a, b) => {
    const sortNameA = _formatNameForSort(iteratee(a))
    const sortNameB = _formatNameForSort(iteratee(b))

    return sortNameA.localeCompare(sortNameB, 'fr', {
      numeric: true,
      ignorePunctuation: false,
      sensitivity: 'variant'
    })
  })
}
